import React from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';

import Modal from '~components/atoms/Modal';
import Text from '~components/atoms/Text';
import CustomClipLoader from '~components/atoms/CustomClipLoader';

import DiscountDetailsForm from '../DiscountDetailsForm';

import * as Styles from './_productManagementDiscountDelete.module.scss';

const DiscountDeleteModal = () => {
    const dispatch = useAppDispatch();

    const selectedDiscountSettings = useAppSelector(state => state.setting.discounts.selectedDiscount);
    const isOpen = useAppSelector(state => state.setting.modals.productManagementDiscountDeleteModalIsOpen);
    const getSettingsError = useAppSelector(state => state.setting.errors.getSettings);
    const getSettingsIsLoading = useAppSelector(state => state.setting.loadings.updateSettings);

    const handleModalOnClose = () => {
        dispatch(combinedActions.settingResetUpdateSettingsState());
        dispatch(combinedActions.settingSetProductManagementDiscountDeleteModalIsOpen(!isOpen));
    };

    return (
        <Modal
            title='Discount Details'
            isOpen={isOpen}
            onClose={handleModalOnClose}
        >
            {getSettingsIsLoading
                ? (
                    <CustomClipLoader
                        blackBorder
                        className={Styles.loader}
                    />
                )
                : (getSettingsError
                    ? (
                        <Text
                            isError
                            label={getSettingsError}
                        />
                    )
                    : (
                        <div className={Styles.container}>
                            <DiscountDetailsForm
                                discountDetails={selectedDiscountSettings}
                                submitButtonLabel='Delete'
                                isEditing
                                inputIsDisabled
                                actionButtonClassName={Styles['delete-button']}
                                actionButtonIsLoading={false}
                            />
                        </div>
                    )
                )
            }
        </Modal>
    );
};

export default DiscountDeleteModal;
